<template>
    <span class="d-flex flex-column">
        <span class="w-100 text-center p-0 m-0">
            <span v-if="value">{{ date }}</span>
            <span v-else>&mdash;</span>
        </span>
        <small class="text-secondary">
            <span v-if="value">{{ time }}</span>
        </small>
    </span>
</template>

<script>
export default {
    name: "DateTimeCell",
    props: {
        value: {}
    },
    computed: {
        date() {
            if (this.value) {
                const parts = this.value.split(' ')
                if (Array.isArray(parts) && parts.length > 0) {
                    return this.value.split(' ')[0]
                }
            }
            return null
        },
        time() {
            if (this.value) {
                const parts = this.value.split(' ')
                if (Array.isArray(parts) && parts.length > 0) {
                    return this.value.split(' ')[1]
                }
            }
            return null
        }
    }
}
</script>

<style scoped>

</style>